import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

// Custom icons
export const createIcon = (color) => {
  return L.divIcon({
    className: "custom-marker",
    html: `<div style="background-color: ${color}; width: 24px; height: 24px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 12px;"></div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
};

export const depotIcon = createIcon("#4f46e5");
export const deliveryIcon = createIcon("#10b981");
export const deliveryIconPending = createIcon("#f59e0b");

// Map bounds fitter component
export const FitBounds = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds && bounds.length > 0) {
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [bounds, map]);
  return null;
};

export const STATUT_OPTIONS = [
  { value: "planifiee", label: "Planifiée", color: "bg-blue-100 text-blue-700" },
  { value: "en_cours", label: "En cours", color: "bg-yellow-100 text-yellow-700" },
  { value: "terminee", label: "Terminée", color: "bg-green-100 text-green-700" },
  { value: "annulee", label: "Annulée", color: "bg-red-100 text-red-700" },
];
